import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogService, ServiceRouter } from '@pershing/pershing-core';
import { Observable } from 'rxjs';
import { ThemeSelectionResponse } from '../model/themeSelectionResponse';
import { AlertServiceDefinition } from './alert-service-definition';
import { NXIMISCServiceDefinition } from './nxi-misc-service.definition';
import { PortalComponentServiceDefinition } from './portal-component-service-definition';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  })
};
@Injectable()
export class PortalComponentService {
  public serviceUrl: string;
  public miscServiceUrl: string;
  public alertsServiceUrl: string;
  saveThemeUrl = '/save-theme';
  constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter) {
    logService.info('NxiRestService : constructor Initializing');
    this.serviceUrl = this.serviceRouter.getServiceRouteURL(PortalComponentServiceDefinition.getInstance());
    this.miscServiceUrl = this.serviceRouter.getServiceRouteURL(NXIMISCServiceDefinition.getInstance());
    this.alertsServiceUrl = this.serviceRouter.getServiceRouteURL(AlertServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true, region: true } });
    window['nxiRestServiceUrl'] = this.serviceUrl; // Setting nxiRestServiceUrl to the window object so that it can be used in the dojo widgets directly
    // this.serviceUrl = 'http://dev-advisor-netxinvestor.bnymellon.net:8081/test-netxinvestor-rest-service-qa-app/services/netxclient.rest-service';
    logService.info('NxiRestService : URL', this.serviceUrl);
  }
  public getLastLoginTime(ibd: string, userId: string): Observable<any> {
    return this.http.get(this.serviceUrl + '/portfolio/get-user-response?userId=' + userId + '&ibd=' + ibd);
  }

  getFinancialAdvisorData(reqBody): Observable<any> {
    return this.http.post(this.miscServiceUrl + '/miscservice/advisordetails', reqBody);
  }

  themeSettingService(theme: string): Observable<ThemeSelectionResponse> {
    this.serviceUrl += '/portfolio';
    return this.http.post<ThemeSelectionResponse>(this.serviceUrl + this.saveThemeUrl, { 'currentTheme': theme }, httpOptions);
  }
  
  setMarketAlertsAgreement(): Observable<any> {
    return this.http.post<any>(this.alertsServiceUrl + 'alert-agreement', {}, httpOptions);
  }
}
